import React, { useEffect, useState } from "react";
import type { AuthUser } from "@meupedaco/shared";
import { useAuth } from "../auth/AuthContext";
import { PageState } from "../components/PageState";

export const ProfilePage: React.FC = () => {
  const { client, updateUser } = useAuth();
  const [profile, setProfile] = useState<AuthUser | null>(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      const response = await client.get("/users/me");
      if (!response.ok) {
        setError("Falha ao carregar perfil.");
        setLoading(false);
        return;
      }
      const payload = (await response.json()) as { data: AuthUser };
      setProfile(payload.data);
      setEmail(payload.data.email);
      setPhone(payload.data.phone ?? "");
      setPhotoUrl(payload.data.photoUrl ?? "");
      setLoading(false);
    };
    load();
  }, [client]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setMessage(null);
    const response = await client.put("/users/me", {
      email,
      phone: phone || null,
      photoUrl: photoUrl || null,
    });
    if (!response.ok) {
      setError("Falha ao atualizar perfil.");
      return;
    }
    const payload = (await response.json()) as { data: AuthUser };
    setProfile(payload.data);
    updateUser(payload.data);
    setMessage("Perfil atualizado.");
  };

  return (
    <div className="container py-4">
      <h1 className="mb-3">Meu perfil</h1>
      <PageState loading={loading} error={error}>
        <div className="row g-4">
          <div className="col-lg-5">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Dados do usuario</h5>
                <p className="text-muted mb-1">Nome: {profile?.name ?? "-"}</p>
                <p className="text-muted mb-1">Cargo: {profile?.title ?? "-"}</p>
                <p className="text-muted mb-0">Email: {profile?.email ?? "-"}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Atualizar contato</h5>
                {message && <div className="alert alert-success">{message}</div>}
                <form onSubmit={handleSubmit} className="d-grid gap-2">
                  <div>
                    <label className="form-label">Email</label>
                    <input
                      className="form-control"
                      type="email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <label className="form-label">Telefone</label>
                    <input
                      className="form-control"
                      value={phone}
                      onChange={(event) => setPhone(event.target.value)}
                    />
                  </div>
                  <div>
                    <label className="form-label">Foto (URL)</label>
                    <input
                      className="form-control"
                      value={photoUrl}
                      onChange={(event) => setPhotoUrl(event.target.value)}
                    />
                  </div>
                  <button className="btn btn-primary" type="submit">
                    Salvar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </PageState>
    </div>
  );
};
